import gql from "graphql-tag";

export default gql`
  mutation requestActuator(
    $actuatorId: Int!,
    $status: Boolean!,
    $maintenanceMode: Boolean!,
    ) {
      requestActuator(
        actuatorId: $actuatorId,
        status: $status,
        maintenanceMode: $maintenanceMode,
      )
    }
`;
